const t = Symbol("listVariant");
export {
  t as listVariantInjectionKey
};
